// global
import { useState, useEffect, useCallback } from 'react';
// utils
import { capitalize, sortString } from 'app/utils';

function useDefaultDropdown({ fetchData, initialOptions = [], dependencies = [] }) {
  const [state, setState] = useState({
    loading: false,
    options: initialOptions
  });

  useEffect(() => {
    setState(prevState => ({ ...prevState, loading: true }));

    fetchData().then(onLoadSuccess).catch(onLoadFail);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies]);

  const onLoadSuccess = useCallback(data => {
    const options = data.map(item => ({
      key: item.value,
      text: capitalize(item.text),
      value: item.value,
      addons: item.addons
    }));

    options.unshift({ text: '-', value: null });
    options.sort((a, b) => sortString(a.text, b.text));

    setState(prevState => ({
      ...prevState,
      loading: false,
      options
    }));
  }, []);

  const onLoadFail = useCallback(() => {
    setState(prevState => ({
      ...prevState,
      loading: false,
      options: []
    }));
  }, []);

  return state;
}

export default useDefaultDropdown;
